import React from 'react';
import { PropTypes } from 'prop-types';

import Step from './Step';
import { Progress } from 'antd';
import StepperTemplate3 from './StepperTemplate3';
import StepperTemplate4 from './StepperTemplate4';

const styles = {
  root: {
    width: '100%',
    minHeight: 0,
    padding: 0,
  },
  stepper: {
    display: 'table',
    width: '100%',
    margin: '0 auto',
  },
};

function Stepper({
  activeStep, steps, disabledSteps,
  activeColor, completeColor, defaultColor, circleFontColor,
  activeTitleColor, completeTitleColor, defaultTitleColor,
  size, circleFontSize, titleFontSize,
  circleTop, titleTop, completeOpacity, activeOpacity, defaultOpacity,
  completeTitleOpacity, activeTitleOpacity, defaultTitleOpacity, barStyle,
  defaultBorderColor, completeBorderColor, activeBorderColor, defaultBorderStyle,
  completeBorderStyle, activeBorderStyle, defaultBarColor, completeBarColor, lineMarginOffset, defaultBorderWidth, backNotAllowed, stepperType
}) {
  let progressFactor = 0;
  let progressPercentage = 0;
  if (steps && steps.length > 0) {

    progressFactor = (activeStep + 1) / (steps.length);
    progressPercentage = progressFactor * 100
  }

  if (stepperType === 'STEPPERTEMPLATE2') {
    return (
      <div className='stepperProgressBarTemplate2'>
        <div>
          <div className='firstLineStepper'>
            <span style={{ fontWeight: 'bold' }}>  Step {activeStep + 1} of {steps.length}</span>
            <Progress percent={progressPercentage} showInfo={false} />
          </div>
        </div>
        <div>
          {steps.map((step, index) => (
            <Step
              key={index}
              width={100 / steps.length}
              title={step.title}
              icon={step.icon}
              href={step.href}
              stepperType={stepperType}
              onClick={step.onClick}
              active={!(disabledSteps || []).includes(index) && index === activeStep}
              completed={!(disabledSteps || []).includes(index) && index < activeStep}
              first={index === 0}
              isLast={index === steps.length - 1}
              index={index}
              activeColor={activeColor}
              completeColor={completeColor}
              defaultColor={defaultColor}
              circleFontColor={circleFontColor}
              activeTitleColor={activeTitleColor}
              completeTitleColor={completeTitleColor}
              defaultTitleColor={defaultTitleColor}
              size={size}
              circleFontSize={circleFontSize}
              titleFontSize={titleFontSize}
              circleTop={circleTop}
              titleTop={titleTop}
              defaultOpacity={defaultOpacity}
              completeOpacity={completeOpacity}
              activeOpacity={activeOpacity}
              defaultTitleOpacity={defaultTitleOpacity}
              completeTitleOpacity={completeTitleOpacity}
              activeTitleOpacity={activeTitleOpacity}
              barStyle={barStyle}
              defaultBorderColor={defaultBorderColor}
              completeBorderColor={completeBorderColor}
              activeBorderColor={activeBorderColor}
              defaultBorderStyle={defaultBorderStyle}
              defaultBorderWidth={defaultBorderWidth}
              completeBorderStyle={completeBorderStyle}
              activeBorderStyle={activeBorderStyle}
              defaultBarColor={defaultBarColor}
              completeBarColor={completeBarColor}
              lineMarginOffset={lineMarginOffset}
              backNotAllowed={backNotAllowed}
            />
          ))}
        </div>
      </div>

    )
  }
  if (stepperType === 'STEPPERTEMPLATE3') {
    let arrowType = false; let arrowType2 = false; let isVertical2 = true;
    return (<StepperTemplate3
      arrowType={arrowType}
      arrowType2={arrowType2}
      steps={steps}
      isVertical2={isVertical2}
      disabledSteps={disabledSteps}
      activeStep={activeStep}
      backNotAllowed={backNotAllowed}
      activeColor="#3267b5"
      activeTitleColor={arrowType || arrowType2 ? "#fff" : "#3267b5"}
      completeColor="#43c260" completeTitleColor={arrowType || arrowType2 ? "#fff" : "#000"}
      defaultColor={arrowType || arrowType2 ? "#bcc0c5b0" : "#a1a4a7cc"}
      defaultTitleColor={arrowType || arrowType2 ? "#fff" : "#a1a4a7cc"} />)

  }
  if (stepperType === 'STEPPERTEMPLATE4') {
    return (<StepperTemplate3
      steps={steps}
      disabledSteps={disabledSteps}
      activeStep={activeStep}
      backNotAllowed={backNotAllowed}
      activeColor="#2762d8"
      activeTitleColor="#fff"
      completeColor="#43c260"
      completeTitleColor="#fff"
      defaultColor="#bcc0c5b0"
      defaultTitleColor="#fff"
    />)

  }
  return (
    <div style={styles.root} className="stepper-root">
      <div style={styles.stepper} className="stepper-step">
        {steps.map((step, index) => (
          <Step
            key={index}
            width={100 / steps.length}
            title={step.title}
            icon={step.icon}
            href={step.href}
            onClick={step.onClick}
            active={!(disabledSteps || []).includes(index) && index === activeStep}
            completed={!(disabledSteps || []).includes(index) && index < activeStep}
            first={index === 0}
            isLast={index === steps.length - 1}
            index={index}
            activeColor={activeColor}
            completeColor={completeColor}
            defaultColor={defaultColor}
            circleFontColor={circleFontColor}
            activeTitleColor={activeTitleColor}
            completeTitleColor={completeTitleColor}
            defaultTitleColor={defaultTitleColor}
            size={size}
            circleFontSize={circleFontSize}
            titleFontSize={titleFontSize}
            circleTop={circleTop}
            titleTop={titleTop}
            defaultOpacity={defaultOpacity}
            completeOpacity={completeOpacity}
            activeOpacity={activeOpacity}
            defaultTitleOpacity={defaultTitleOpacity}
            completeTitleOpacity={completeTitleOpacity}
            activeTitleOpacity={activeTitleOpacity}
            barStyle={barStyle}
            defaultBorderColor={defaultBorderColor}
            completeBorderColor={completeBorderColor}
            activeBorderColor={activeBorderColor}
            defaultBorderStyle={defaultBorderStyle}
            defaultBorderWidth={defaultBorderWidth}
            completeBorderStyle={completeBorderStyle}
            activeBorderStyle={activeBorderStyle}
            defaultBarColor={defaultBarColor}
            completeBarColor={completeBarColor}
            lineMarginOffset={lineMarginOffset}
            backNotAllowed={backNotAllowed}
          />
        ))}
      </div>
    </div>
  );
}

Stepper.defaultProps = {
  activeStep: 0,
};

Stepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array,
  activeColor: PropTypes.string,
  completeColor: PropTypes.string,
  defaultColor: PropTypes.string,
  activeTitleColor: PropTypes.string,
  completeTitleColor: PropTypes.string,
  defaultTitleColor: PropTypes.string,
  circleFontColor: PropTypes.string,
  size: PropTypes.number,
  circleFontSize: PropTypes.number,
  titleFontSize: PropTypes.number,
  circleTop: PropTypes.number,
  titleTop: PropTypes.number,
  defaultOpacity: PropTypes.string,
  completeOpacity: PropTypes.string,
  activeOpacity: PropTypes.string,
  defaultTitleOpacity: PropTypes.string,
  completeTitleOpacity: PropTypes.string,
  activeTitleOpacity: PropTypes.string,
  barStyle: PropTypes.string,
  defaultBarColor: PropTypes.string,
  completeBarColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  completeBorderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  defaultBorderStyle: PropTypes.string,
  completeBorderStyle: PropTypes.string,
  activeBorderStyle: PropTypes.string,
  lineMarginOffset: PropTypes.number,
  defaultBorderWidth: PropTypes.number
};

export default Stepper;
